export const SEX_FEMALE = 0;
export const SEX_MALE = 1;

export const sexShortLabel = (sex: number | null | undefined): string => {
  if (sex === SEX_FEMALE) return 'Женский';
  if (sex === SEX_MALE) return 'Мужской';
  return '';
};

export const sexProfileLabel = (sex: number | null | undefined): string => {
  if (sex === SEX_FEMALE) return 'Женщина';
  if (sex === SEX_MALE) return 'Мужчина';
  return '-';
};

export const SEX_SELECT_OPTIONS = [
  { value: '', label: 'Не указан' },
  { value: String(SEX_MALE), label: 'Мужской' },
  { value: String(SEX_FEMALE), label: 'Женский' },
] as const;

export const SEX_CHILD_SELECT_OPTIONS = [
  { value: '', label: 'Пол' },
  { value: String(SEX_MALE), label: 'Мужской' },
  { value: String(SEX_FEMALE), label: 'Женский' },
] as const;
